import type { GameResultContentMap } from "@micro-screens/src/types/result-content";

import {
  FAILURE_RESULT_LABELS,
  SUCCESS_RESULT_LABELS,
} from "./result-screen-labels";

export const DEFAULT_SUCCESS_STAGE_RESULT_CONTENT: GameResultContentMap = {
  1: SUCCESS_RESULT_LABELS,
  2: SUCCESS_RESULT_LABELS,
  3: SUCCESS_RESULT_LABELS,
  4: SUCCESS_RESULT_LABELS,
  5: SUCCESS_RESULT_LABELS,
  6: SUCCESS_RESULT_LABELS,
  7: SUCCESS_RESULT_LABELS,
};

export const DEFAULT_FAILURE_STAGE_RESULT_CONTENT: GameResultContentMap = {
  1: FAILURE_RESULT_LABELS,
  2: FAILURE_RESULT_LABELS,
  3: FAILURE_RESULT_LABELS,
  4: FAILURE_RESULT_LABELS,
  5: FAILURE_RESULT_LABELS,
  6: FAILURE_RESULT_LABELS,
  7: FAILURE_RESULT_LABELS,
};
